import script from "./MenuAuthenticatedUser.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuAuthenticatedUser.vue?vue&type=script&setup=true&lang=ts"

import "./MenuAuthenticatedUser.vue?vue&type=style&index=0&id=15306376&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15306376"]])

export default __exports__